import { Scissors, Zap, PenLine, Flame, Users, ArrowUpRight } from "lucide-react";
import { BookLink, Chapter, Reveal } from "./booking";

const SERVICES = [
  {
    icon: Scissors,
    title: "Classic Haircuts",
    desc: "Professional classic cuts tailored to your style.",
  },
  {
    icon: Zap,
    title: "Skin Fades & Taper Fades",
    desc: "Precision fades, tapers, and modern styles finished with attention to detail.",
  },
  {
    icon: PenLine,
    title: "Beard Trims & Line-Ups",
    desc: "Clean beard shaping, trims, and sharp line-ups.",
  },
  {
    icon: Flame,
    title: "Hot Towel Shaves",
    desc: "A traditional hot towel grooming experience with a modern barber-shop feel.",
  },
  {
    icon: Users,
    title: "Kids & Senior Cuts",
    desc: "Quality cuts for kids and seniors in a comfortable, welcoming environment.",
  },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="px-5 lg:px-12 py-20 lg:py-32 border-t border-border">
      <Chapter index="02" title="Services" />
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
        <Reveal>
          <h2 className="font-display uppercase leading-[0.9] text-5xl sm:text-6xl lg:text-7xl">
            The menu.
            <br />
            <span className="text-primary">No shortcuts.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="max-w-sm text-base leading-relaxed text-muted-foreground font-light">
            Every service is booked online in seconds. Current pricing lives on the live booking
            menu — no surprises.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
        {SERVICES.map((s, i) => (
          <Reveal
            key={s.title}
            delay={i * 0.06}
            className={`bg-card p-8 lg:p-10 flex flex-col group hover:bg-secondary transition-colors duration-500 ${
              i === 1 ? "lg:row-span-1" : ""
            }`}
          >
            <div className="flex items-start justify-between">
              <s.icon size={28} className="text-primary" aria-hidden="true" />
              <span className="font-mono text-xs text-foreground/40 tracking-[0.2em]">
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <h3 className="font-display uppercase text-3xl sm:text-4xl mt-8 leading-none">{s.title}</h3>
            <p className="mt-4 text-sm sm:text-base leading-relaxed text-muted-foreground font-light flex-1">
              {s.desc}
            </p>
            <BookLink
              testid={`service-book-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="mt-8 inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] uppercase text-foreground/70 group-hover:text-primary transition-colors duration-300"
            >
              Book Now
              <ArrowUpRight
                size={14}
                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                aria-hidden="true"
              />
            </BookLink>
          </Reveal>
        ))}
        <Reveal delay={0.3} className="bg-primary p-8 lg:p-10 flex flex-col justify-between">
          <h3 className="font-display uppercase text-3xl sm:text-4xl leading-none text-primary-foreground">
            Not sure what
            <br />
            you need?
          </h3>
          <div className="mt-8">
            <p className="text-sm text-primary-foreground/80 font-light leading-relaxed">
              Book a consultation with your cut — our barbers will dial in the right style for you.
            </p>
            <BookLink
              testid="service-book-consult"
              className="mt-6 inline-flex items-center gap-2 font-mono text-xs tracking-[0.25em] uppercase text-primary-foreground border-b border-primary-foreground/50 pb-1 hover:border-primary-foreground transition-colors duration-300"
            >
              Book Now <ArrowUpRight size={14} aria-hidden="true" />
            </BookLink>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
